export default __webpack_public_path__ + "static/media/Group 3186@2x.70b8b383.png";